import React, { useState } from 'react';
import { Button, Modal } from '../components/ui';

function SplashPage({ onPlayNow, onTipDevs, onLogout }) {
    const [showTipModal, setShowTipModal] = useState(false);

    const handlePlayNow = () => {
        if (onPlayNow) {
            onPlayNow();
        }
    };

    const handleTipDevs = () => {
        setShowTipModal(true);
    };

    const handleLogout = () => {
        if (onLogout) {
            onLogout();
        }
    };

    const handleCloseTipModal = () => {
        setShowTipModal(false);
    };

    return (
        <div
            style={{
                left: window.innerWidth <= 768 ? 0 : 530,
                position: 'relative',
                width: window.innerWidth <= 768 ? '100%' : '50%',
                height: '98.5vh',
                backgroundImage: "url('/art/playBackground.png')",
                backgroundSize: 'cover',
                backgroundPosition: 'center center',
                backgroundRepeat: 'no-repeat',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                overflow: 'hidden'
            }}
        >
            {/* MYTHIC SPORTS PRESENTS text - positioned at top right */}
            <div
                style={{
                    position: 'absolute',
                    top: '10%',
                    right: '2%',
                    fontSize: window.innerWidth <= 768 ? '15px' : '28px',
                    fontWeight: 'bold',
                    color: '#000000',
                    textAlign: 'right',
                    letterSpacing: '2px',
                    fontFamily: 'Arial, sans-serif',
                    background: 'rgba(255,255,255,0.7)',
                    borderRadius: '10px',
                    padding: '6px 18px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
                }}
            >
                MYTHIC SPORTS PRESENTS:
            </div>

            {/* MYTHIC FOOTBALL text - positioned center with background */}
            <div
                style={{
                    position: 'absolute',
                    top: '35%',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    textAlign: 'center',
                    fontFamily: 'Arial, sans-serif',
                    fontWeight: 'bold',
                    lineHeight: '1.1',
                    background: 'rgba(255,255,255,0.3)',
                    borderRadius: '24px',
                    padding: window.innerWidth <= 768 ? '18px 18px' : '28px 36px',
                }}
            >
                <div
                    style={{
                        fontSize: window.innerWidth <= 768 ? '36px' : '48px',
                        color: '#DC2626', // Red color for MYTHIC
                        marginBottom: '8px',
                        letterSpacing: '3px',
                        textShadow: '2px 2px 4px rgba(0,0,0,0.3)'
                    }}
                >
                    MYTHIC
                </div>
                <div
                    style={{
                        fontSize: window.innerWidth <= 768 ? '36px' : '48px',
                        color: '#2563EB', // Blue color for FOOTBALL
                        letterSpacing: '3px',
                        textShadow: '2px 2px 4px rgba(0,0,0,0.3)'
                    }}
                >
                    FOOTBALL
                </div>
            </div>

            {/* PLAY NOW! button - positioned center-bottom */}
            <Button
                onClick={handlePlayNow}
                variant="primary"
                style={{
                    position: 'absolute',
                    top: '65%',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    backgroundColor: 'rgba(255, 255, 255, 0.95)',
                    color: '#1F2937',
                    border: '3px solid rgba(0,0,0,0.2)',
                    borderRadius: '12px',
                    padding: window.innerWidth <= 768 ? '15px 40px' : '20px 60px',
                    fontSize: window.innerWidth <= 768 ? '24px' : '32px',
                    fontWeight: 'bold',
                    fontFamily: 'Arial, sans-serif',
                    cursor: 'pointer',
                    letterSpacing: '2px',
                    boxShadow: '0 6px 12px rgba(0,0,0,0.3)',
                    transition: 'all 0.3s ease',
                    textShadow: '1px 1px 2px rgba(0,0,0,0.1)'
                }}
                onMouseEnter={(e) => {
                    e.target.style.backgroundColor = 'rgba(255, 255, 255, 1)';
                    e.target.style.transform = 'translateX(-50%) scale(1.05)';
                    e.target.style.boxShadow = '0 8px 16px rgba(0,0,0,0.4)';
                }}
                onMouseLeave={(e) => {
                    e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.95)';
                    e.target.style.transform = 'translateX(-50%) scale(1)';
                    e.target.style.boxShadow = '0 6px 12px rgba(0,0,0,0.3)';
                }}
            >
                PLAY NOW!
            </Button>

            {/* TIP THE DEVS button - positioned bottom */}
            <Button
                onClick={handleTipDevs}
                variant="secondary"
                style={{
                    position: 'absolute',
                    bottom: '12%',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                    color: '#374151',
                    border: '2px solid rgba(0,0,0,0.2)',
                    borderRadius: '8px',
                    padding: window.innerWidth <= 768 ? '10px 25px' : '12px 30px',
                    fontSize: window.innerWidth <= 768 ? '16px' : '20px',
                    fontWeight: 'bold',
                    fontFamily: 'Arial, sans-serif',
                    cursor: 'pointer',
                    letterSpacing: '1px',
                    boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
                    transition: 'all 0.3s ease',
                    textShadow: '1px 1px 2px rgba(0,0,0,0.1)'
                }}
                onMouseEnter={(e) => {
                    e.target.style.backgroundColor = 'rgba(255, 255, 255, 1)';
                    e.target.style.transform = 'translateX(-50%) scale(1.05)';
                }}
                onMouseLeave={(e) => {
                    e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.9)';
                    e.target.style.transform = 'translateX(-50%) scale(1)';
                }}
            >
                TIP THE DEVS
            </Button>

            {/* Logout button - positioned lower left */}
            <Button
                onClick={handleLogout}
                variant="secondary"
                style={{
                    position: 'absolute',
                    bottom: '20px',
                    left: '20px',
                    backgroundColor: 'rgba(220, 38, 38, 0.9)', // Red background
                    color: 'white',
                    border: '2px solid rgba(0,0,0,0.2)',
                    borderRadius: '6px',
                    padding: window.innerWidth <= 768 ? '8px 16px' : '10px 20px',
                    fontSize: window.innerWidth <= 768 ? '14px' : '16px',
                    fontWeight: 'bold',
                    fontFamily: 'Arial, sans-serif',
                    cursor: 'pointer',
                    letterSpacing: '1px',
                    boxShadow: '0 4px 8px rgba(0,0,0,0.3)',
                    transition: 'all 0.3s ease',
                    textShadow: '1px 1px 2px rgba(0,0,0,0.2)'
                }}
                onMouseEnter={(e) => {
                    e.target.style.backgroundColor = 'rgba(185, 28, 28, 1)';
                    e.target.style.transform = 'scale(1.05)';
                }}
                onMouseLeave={(e) => {
                    e.target.style.backgroundColor = 'rgba(220, 38, 38, 0.9)';
                    e.target.style.transform = 'scale(1)';
                }}
            >
                LOGOUT
            </Button>

            {/* Tip Modal */}
            <Modal
                isOpen={showTipModal}
                onClose={handleCloseTipModal}
                title="💰 Tip the Devs"
            >
                <p
                    style={{
                        margin: '0 0 30px 0',
                        fontSize: '18px',
                        color: '#4B5563',
                        fontFamily: 'Arial, sans-serif'
                    }}
                >
                    LINK TO REAL MONEY HERE
                </p>
                <Button
                    onClick={handleCloseTipModal}
                    variant="primary"
                    style={{
                        backgroundColor: '#3B82F6',
                        color: 'white',
                        border: 'none',
                        borderRadius: '6px',
                        padding: '12px 24px',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        cursor: 'pointer',
                        fontFamily: 'Arial, sans-serif',
                        transition: 'background-color 0.3s ease'
                    }}
                    onMouseEnter={(e) => e.target.style.backgroundColor = '#2563EB'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = '#3B82F6'}
                >
                    Close
                </Button>
            </Modal>
        </div>
    );
}

export default SplashPage;